///<reference path="../../../../typings/index.d.ts"/>

module Meevo.Components.ShortCuts {

    export enum GroupLevels {
        Global = 0,
        Plugin = 1,
        Menu = 2,
        SubMenu = 3,
        Modal = 4,
    }
}